export const SEARCH_RESULT_FLEX_BEHAVIOR_OPTIONS = {
  CANCEL_FOR_ANY_REASON: 'CANCEL_FOR_ANY_REASON',
  AIR_REBOOKING: 'AIR_REBOOKING'
};
//# sourceMappingURL=ancillaries.js.map